import { Container } from 'react-bootstrap'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { Outlet } from 'react-router-dom'

function HomePage() {
	return (
		<Container fluid className='p-0'>
			<Header/>
			<Container fluid className='main-content p-0'>
				<Outlet/> {/* child componenets goes here... */}
			</Container>
			<Footer/>
		</Container>
	)
}

export default HomePage